/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/798/interface/api/cat_7767
 */

import { message } from 'ant-design-vue'
import {
  common_queryCountryInfo_post,
  common_queryLanguageInfo_post,
  common_querySiteInfo_get,
  common_querySiteInfo_post,
  common_queryStateInfo_post,
  common_uploadFile_post,
  common_listLanguageInfo_get
} from 'server/modules/7767'

// queryCountryInfo
export const common_queryCountryInfo_post_ = async function(params) {
  const { success, data, retInfo } = await common_queryCountryInfo_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// queryLanguageInfo
export const common_queryLanguageInfo_post_ = async function(params) {
  const { success, data, retInfo } = await common_queryLanguageInfo_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// querySiteInfo
export const common_querySiteInfo_get_ = async function(params) {
  const { success, data, retInfo } = await common_querySiteInfo_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// querySiteInfo
export const common_querySiteInfo_post_ = async function(params) {
  const { success, data, retInfo } = await common_querySiteInfo_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// queryStateInfo
export const common_queryStateInfo_post_ = async function(params) {
  const { success, data, retInfo } = await common_queryStateInfo_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// uploadFile
export const common_uploadFile_post_ = async function(params) {
  const { success, data, retInfo } = await common_uploadFile_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// listLanguageInfo
export const common_listLanguageInfo_get_ = async function(params) {
  const { success, data, retInfo } = await common_listLanguageInfo_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
